<app-scroll-view class="scroll-view">
  <section class="notes-container" #contentEl>
    <div class="title">
      <span
        class="text"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      >
        {{ translationService.getCurrentLanguage()["sketch-type"] }}
      </span>
    </div>

    <div class="drawing-mode-list">
      <ng-container *ngFor="let item of noteTypeItemList">
        <div
          class="draw-item"
          #tooltipEl
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        >
          <app-button
            [buttonType]="item.active ? 'primary' : 'normal'"
            styleType="text"
            shapeType="circle"
            sizeType="large"
            [icon]="item.icon"
            (click)="onSelectNoteTypeClick(item)"
            [disabled]="!!(!item.active && (editingActiveObservable | async))"
          ></app-button>
        </div>

        <app-tooltip
          *ngIf="!!item.name"
          [target]="tooltipEl"
          verticalAlignment="top"
          horizontalAlignment="center"
        >
          {{ item.name }}
        </app-tooltip>
      </ng-container>
    </div>

    <ng-container *ngIf="!!formGroup">
      <form class="settings-style-draw-container" [formGroup]="formGroup">
        <div class="field-set" *ngIf="shouldShowField('pointStyle')">
          <label label>
            {{ translationService.getCurrentLanguage()["point-type"] }}
          </label>

          <app-select-box
            formControlName="pointStyle"
            [items]="pointStyleList"
            displayExpr="label"
            valueExpr="value"
            [showClearButton]="false"
            [showErrorEnabled]="false"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          ></app-select-box>
        </div>

        <div class="field-set" *ngIf="shouldShowField('fillColor')">
          <label label>
            <ng-container [ngSwitch]="noteEditorTypeSelected">
              <ng-container *ngSwitchCase="editorTypes.Line">
                {{ translationService.getCurrentLanguage()["line-color"] }}
              </ng-container>

              <ng-container *ngSwitchCase="editorTypes.Point">
                {{ translationService.getCurrentLanguage()["point-color"] }}
              </ng-container>

              <ng-container *ngSwitchDefault>
                {{ translationService.getCurrentLanguage()["fill-color"] }}
              </ng-container>
            </ng-container>
          </label>
          <app-input-color-box
            formControlName="fillColor"
            [showClearButton]="false"
            [showErrorEnabled]="false"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
          </app-input-color-box>
        </div>

        <div class="field-set" *ngIf="shouldShowField('outlineColor')">
          <label label>{{
            translationService.getCurrentLanguage()["outline-color"]
          }}</label>
          <app-input-color-box
            formControlName="outlineColor"
            [showClearButton]="false"
            [showErrorEnabled]="false"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
          </app-input-color-box>
        </div>

        <div class="field-set" *ngIf="shouldShowField('outlineWidth')">
          <label label>{{
            translationService.getCurrentLanguage()["outline-thickness"]
          }}</label>
          <app-input-box
            formControlName="outlineWidth"
            [type]="'number'"
            [showClearButton]="false"
            [showErrorEnabled]="false"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
            [min]="0"
          >
          </app-input-box>
        </div>

        <div class="field-set" *ngIf="shouldShowField('size')">
          <label label>
            {{ translationService.getCurrentLanguage()["point-size"] }}
          </label>
          <app-input-box
            formControlName="size"
            [type]="'number'"
            [showClearButton]="false"
            [showErrorEnabled]="false"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
            [min]="0"
          >
          </app-input-box>
        </div>

        <div class="field-set" *ngIf="shouldShowField('outlineStyle')">
          <label label>
            {{ translationService.getCurrentLanguage()["line-type"] }}</label
          >
          <app-select-box
            formControlName="outlineStyle"
            [items]="lineStyleList"
            displayExpr="label"
            valueExpr="value"
            [showClearButton]="false"
            [showErrorEnabled]="false"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          ></app-select-box>
        </div>

        <div class="field-set" *ngIf="shouldShowField('text')">
          <label label>{{
            translationService.getCurrentLanguage().text
          }}</label>
          <app-input-box
            formControlName="text"
            [showClearButton]="false"
            [showErrorEnabled]="false"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
          </app-input-box>
        </div>

        <div class="field-set" *ngIf="shouldShowField('fontSize')">
          <label label>{{
            translationService.getCurrentLanguage()["text-size"]
          }}</label>
          <app-input-box
            formControlName="fontSize"
            [type]="'number'"
            [showClearButton]="false"
            [showErrorEnabled]="false"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
            [min]="0"
          >
          </app-input-box>
        </div>

        <div class="field-set" *ngIf="shouldShowField('fontColor')">
          <label label>{{
            translationService.getCurrentLanguage()["text-color"]
          }}</label>
          <app-input-color-box
            formControlName="fontColor"
            [showClearButton]="false"
            [showErrorEnabled]="false"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
          </app-input-color-box>
        </div>

        <div class="field-set">
          <label label>{{
            translationService.getCurrentLanguage().transparency
          }}</label>
          <app-range-slider
            formControlName="opacity"
            class="range-slider"
            [step]="0.01"
            [min]="0"
            [max]="1"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          ></app-range-slider>
        </div>
      </form>

      <div class="button-container">
        <div class="button-container-wrap">
          <div
            class="btn-item"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
            <app-button
              buttonType="primary"
              styleType="contained"
              [text]="translationService.getCurrentLanguage().draw"
              width="8.5rem"
              (click)="onBtnStartDrawClick()"
              [disabled]="
                !!(
                  (editingActiveObservable | async) ||
                  (drawingActiveObservable | async)
                )
              "
            ></app-button>
          </div>

          <div
            class="btn-item"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
            <app-button
              buttonType="primary"
              styleType="contained"
              [text]="translationService.getCurrentLanguage().edit"
              width="8.5rem"
              (click)="onBtnApplyChangesClick()"
              [disabled]="!(editingActiveObservable | async)"
            ></app-button>
          </div>

          <div
            class="btn-item"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
            <app-button
              buttonType="primary"
              styleType="contained"
              [text]="translationService.getCurrentLanguage().cancel"
              width="8.5rem"
              (click)="onBtnCancelDrawClick()"
              [disabled]="!(editingActiveObservable | async)"
            ></app-button>
          </div>
        </div>

        <div class="button-container-wrap">
          <div
            class="btn-item"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
            <app-button
              buttonType="normal"
              styleType="outlined"
              [text]="translationService.getCurrentLanguage().delete"
              width="96%"
              (click)="onBtnDeleteClick()"
              [disabled]="!(editingActiveObservable | async)"
            ></app-button>
          </div>

          <div
            class="btn-item"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
            <app-button
              buttonType="normal"
              styleType="outlined"
              [text]="translationService.getCurrentLanguage()['delete-all']"
              width="96%"
              (click)="onBtnDeleteAllClick()"
            ></app-button>
          </div>
        </div>
      </div>
    </ng-container>
  </section>
</app-scroll-view>
